import {
  USER_ROLES,
  normalizeRoleCode,
  resolveUserRoleName,
} from "../../../../constants";
import { canReviewClinicalForms } from "../../patientPermissions";

/** Role from localStorage or a stripped user object. */
export function resolveFormActorRole(currentUser, fallback = "") {
  return resolveUserRoleName(currentUser) || fallback || "";
}

export function isFormReviewerRole(role) {
  if (canReviewClinicalForms(role)) return true;
  const code = normalizeRoleCode(role);
  return code === "ADMIN" || code === "OA" || code === "SUPERADMIN";
}

export function isFormEditorRole(role, editorRoles = []) {
  if (!role) return false;
  const code = normalizeRoleCode(role);
  return editorRoles.some(
    (allowed) => allowed === role || normalizeRoleCode(allowed) === code,
  );
}

/**
 * Discipline notes stay editable for that discipline + Admin/OA review.
 * Other clinical roles remain view-only.
 */
export function applyDisciplineFormPermissions(
  basePermissions,
  role,
  editorRoles,
  lockedReason,
) {
  if (isFormReviewerRole(role) || isFormEditorRole(role, editorRoles)) {
    return basePermissions;
  }
  return {
    ...basePermissions,
    canEdit: false,
    canSendToOffice: false,
    canToBeSign: false,
    canSignSignatures: false,
    canReview: false,
    lockedReason,
  };
}

export const ST_FORM_EDITOR_ROLES = [USER_ROLES.ST];
export const OT_FORM_EDITOR_ROLES = [USER_ROLES.OT, USER_ROLES.OTA];
export const PT_FORM_EDITOR_ROLES = [USER_ROLES.PT, USER_ROLES.PTA];
export const RN_FORM_EDITOR_ROLES = [USER_ROLES.RN, USER_ROLES.LVN];
export const MSW_FORM_EDITOR_ROLES = [USER_ROLES.MSW];
export const CHHA_FORM_EDITOR_ROLES = [USER_ROLES.HHA];
